import React from "react";
import "../style/becomemember.css";

export default function LandingSection() {
  return (
    <section className="landing-wrapper">
      <div className="become-member-content">
        <h1 className="become-member-title">Become A PArM Member?</h1>

      <a href="/membership-registration-parm">
        <button className="become-member-register-btn">
          Register Now →
        </button>
        </a>

        <a href="/membership-parm" className="become-member-more-link">
          Find out more ↗
        </a>
      </div>
    </section>
  );
}
